export const host = 'https://gupshup-server.onrender.com'

export const registerApi = `${host}/api/register`;
export const loginApi = `${host}/api/login`;

export const avatarApi = `${host}/api/avatar/`;
export const searchApi = `${host}/api/search/`;
export const addContactApi = `${host}/api/contact/`
export const getAllContactsApi = `${host}/api/contact/`

export const addMessageApi = `${host}/message/add`;
export const getAllMessagesApi = `${host}/message`
